import { createGDCurrentUserRepository as goodDataCurrentUser } from './goodDataCurrentUser';
import { createGDDashboardRepository as goodDataDashboards } from './goodDataDashboards';

export const repositoryFactories = {
    goodDataCurrentUser,
    goodDataDashboards,
};
